"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var base_1 = tslib_1.__importDefault(require("../base"));
var address_1 = tslib_1.__importDefault(require("./address"));
var w9_1 = tslib_1.__importDefault(require("./w9"));
var account_1 = tslib_1.__importDefault(require("./account"));
var freefield_1 = tslib_1.__importDefault(require("./freefield"));
var normalization_1 = require("rest-resource/dist/helpers/normalization");
var VendorResource = /** @class */ (function (_super) {
    tslib_1.__extends(VendorResource, _super);
    function VendorResource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VendorResource.endpoint = '/vendors';
    VendorResource.MODEL_NAME = 'vendor';
    VendorResource.related = {
        address_contact: address_1.default,
        address_selected: address_1.default,
        address_mailing: address_1.default,
        address_billing: address_1.default,
        default_address: address_1.default,
        parent: VendorResource,
        w9: w9_1.default,
        default_accounts: account_1.default,
        default_free_fields: freefield_1.default,
        petty_cash_account: account_1.default,
        petty_cash_custodian_account: account_1.default,
    };
    // Manually override normalization -- endpoints using some address fields are nested
    // This can be removed once we get rid of NestedSerializer in backend @todo
    VendorResource.normalization = {
        parent: new normalization_1.StringNormalizer(),
        w9: new normalization_1.StringNormalizer(),
        default_accounts: new normalization_1.StringNormalizer(),
        default_free_fields: new normalization_1.StringNormalizer(),
        petty_cash_account: new normalization_1.StringNormalizer(),
        petty_cash_custodian_account: new normalization_1.StringNormalizer(),
    };
    return VendorResource;
}(base_1.default));
exports.default = VendorResource;
//# sourceMappingURL=vendor.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@sigmacloud/sigma-client/dist/resources/system/vendor.js
// module id = 6Alc
// module chunks = 0